import React, { useState } from "react";
import { showNotification } from "../../utils";
import "./batch_shared.css";

const ACCEPTED_EXTENSIONS = [".xlsx", ".xls"];

const isExcelFile = (file) =>
  ACCEPTED_EXTENSIONS.some((ext) => file.name.toLowerCase().endsWith(ext));

const ResultSummary = ({ result }) => {
  if (!result) return null;

  return (
    <div className="batch-result-summary">
      <h4>Resultado</h4>
      <pre>{JSON.stringify(result, null, 2)}</pre>
    </div>
  );
};

const ExcelUploadPanel = ({
  title,
  description,
  helpText,
  submitLabel,
  onSubmit,
}) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async () => {
    if (!file) {
      showNotification("Aviso", "Selecciona un archivo Excel", "warning");
      return;
    }

    if (!isExcelFile(file)) {
      showNotification(
        "Error",
        "Solo se aceptan archivos Excel (.xlsx o .xls)",
        "danger"
      );
      return;
    }

    setLoading(true);
    try {
      const response = await onSubmit(file);
      setResult(response);
      showNotification("Éxito", "Proceso completado correctamente", "success");
    } catch (error) {
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="batch-panel">
      <h3>{title}</h3>
      {description && <p className="batch-panel-description">{description}</p>}
      {helpText && <pre className="batch-help-text">{helpText}</pre>}

      <div className="batch-file-row">
        <label className="batch-file-label">
          <span className="batch-file-button">Seleccionar archivo</span>
          <input
            type="file"
            className="batch-file-input"
            accept=".xlsx,.xls"
            onChange={(e) => {
              setFile(e.target.files?.[0] || null);
              setResult(null);
            }}
          />
        </label>
        {file && <span className="batch-file-name">{file.name}</span>}
      </div>

      <input
        className="button_register batch-action-btn"
        type="button"
        value={loading ? "Procesando..." : submitLabel}
        disabled={loading}
        onClick={handleSubmit}
      />

      <ResultSummary result={result} />
    </div>
  );
};

export default ExcelUploadPanel;
